<mat-card appearance="outlined">
  <mat-card-content>

    <mat-tab-group preserveContent mat-stretch-tabs="false" mat-align-tabs="start" selectedIndex="1">
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>contact_phone</mat-icon>
          &nbsp;{{'caseload.tabs.contacts.title' | translate}}
        </ng-template>
        <div class="expansion-panel-header">
          <button matButton (click)="toggleContactFilter()" style="color:white!important">
            <mat-icon>filter_alt</mat-icon>
            {{'caseload.tabs.contacts.panel-title' | translate}}
          </button>
        </div>
        <mat-accordion>
          <mat-expansion-panel [expanded]="contactFilterOpened">
            <div class="filter-container">
              <div class="column">
                <div>
                  <mat-form-field>
                    <mat-label>{{'caseload.tabs.contacts.filters.from' | translate}}</mat-label>
                    <input matInput [matDatepicker]="dateFromPicker" [(ngModel)]="contactEventConfig.filters!.dateFrom!">
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateFromPicker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field>
                    <mat-label>{{'caseload.tabs.contacts.filters.to' | translate}}</mat-label>
                    <input matInput [matDatepicker]="dateToPicker" [(ngModel)]="contactEventConfig.filters!.dateTo!">
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateToPicker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div>
                  <mat-checkbox [(ngModel)]="contactEventConfig.filters!.showHistoric!">{{'caseload.tabs.contacts.filters.show-historic' | translate}}</mat-checkbox>
                  <mat-checkbox [(ngModel)]="contactEventConfig.filters!.includeDeletedEvents!">{{'caseload.tabs.contacts.filters.include-deleted' | translate}}</mat-checkbox>
                </div>
              </div>
              <div class="column">
                <div>
                  <mat-form-field>
                    <mat-label>{{'caseload.tabs.contacts.filters.client-id' | translate}}</mat-label>
                    <input type="text" matInput [(ngModel)]="contactEventConfig.filters!.clientId!" placeholder="{{'caseload.tabs.contacts.filters.client-id' | translate}}">
                  </mat-form-field>
                </div>
                <div>
                </div>
                <div>

                </div>
                <div>
                  <button matButton="filled" (click)="ApplyContactsFilters()">
                    <mat-icon>filter_alt</mat-icon>
                    <span>{{'caseload.tabs.contacts.apply-filter' | translate}}</span>
                  </button>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <app-paged-datatable-component [columns]="contactsColumns" (pagedDatatablePageChange)="loadContactsData($event)" (pagedDatatableSortChange)="sortContactsData($event)" #contacts></app-paged-datatable-component>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>groups</mat-icon>
          &nbsp;{{'caseload.tabs.caseload.title' | translate}}
        </ng-template>
        <div class="expansion-panel-header">
          

          <button matButton (click)="toggleCaseloadFilter()" style="color:white!important">
            <mat-icon>filter_alt</mat-icon>
            {{'caseload.tabs.caseload.panel-filters.title' | translate}}
          </button>

          <button matButton (click)="toggleViewedClients()" style="color:white!important">
            <mat-icon>visibility</mat-icon>
            {{'caseload.tabs.caseload.panel-viewed-clients.title' | translate}}
          </button>
        </div>
        <mat-accordion>
          @if( clientCaseloadConfig && clientCaseloadConfig.filters ){
          <mat-expansion-panel [expanded]="caseloadFilterOpened">

            <div class="filter-container">
              <div class="column">
                <div>
                  <mat-form-field>
                    <mat-label>{{'caseload.tabs.caseload.panel-filters.filters.first-name' | translate}}</mat-label>
                    <input type="text" matInput placeholder="{{'caseload.tabs.caseload.panel-filters.filters.first-name' | translate}}" [(ngModel)]="clientCaseloadConfig.filters!.firstName!">
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field>
                    <mat-label>{{'caseload.tabs.caseload.panel-filters.filters.last-name' | translate}}</mat-label>
                    <input type="text" matInput placeholder="{{'caseload.tabs.caseload.panel-filters.filters.last-name' | translate}}" [(ngModel)]="clientCaseloadConfig.filters!.lastName!">
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field>
                    <mat-label>{{'caseload.tabs.caseload.panel-filters.filters.phone' | translate}}</mat-label>
                    <span matTextPrefix>+1 &nbsp;</span>
                    <input type="tel" matInput placeholder="555-555-1234" [(ngModel)]="clientCaseloadConfig.filters!.phone!">
                    <mat-icon matSuffix>call</mat-icon>
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field>
                    <mat-label>{{'caseload.tabs.caseload.panel-filters.filters.date-of-birth' | translate}}</mat-label>
                    <input matInput [matDatepicker]="picker" [(ngModel)]="clientCaseloadConfig.filters!.dateOfBirth!">
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div class="column">
                <div>
                  <mat-form-field>
                    <mat-label>{{'caseload.tabs.caseload.panel-filters.filters.client-id' | translate}}</mat-label>
                    <input type="text" matInput [(ngModel)]="clientCaseloadConfig.filters!.clientId!" placeholder="Client Id">
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field>
                    <mat-label>{{'caseload.tabs.caseload.panel-filters.filters.external-id' | translate}}</mat-label>
                    <input type="text" matInput [(ngModel)]="clientCaseloadConfig.filters!.externalClientId!" placeholder="External Id">
                  </mat-form-field>
                </div>
                <div>
                  <mat-checkbox [(ngModel)]="clientCaseloadConfig.filters!.shouldIncludeActive!">{{'caseload.tabs.caseload.panel-filters.filters.active' | translate}}</mat-checkbox>
                  <mat-checkbox [(ngModel)]="clientCaseloadConfig.filters!.shouldIncludeInactive!">{{'caseload.tabs.caseload.panel-filters.filters.inactive' | translate}}</mat-checkbox>
                </div>
                <div>
                  <button matButton="filled" (click)="ApplyClientFilters()">
                    <mat-icon>filter_alt</mat-icon>
                    <span>{{'caseload.tabs.caseload.panel-filters.apply-filter' | translate}}</span>
                  </button>
                </div>
              </div>
            </div>

          </mat-expansion-panel>
          }

          <mat-expansion-panel [expanded]="viewedClientsOpened">
            <div>
              @for (client of viewedClients; track client) {
              <a matButton="tonal" [routerLink]="`/main/client/summary/${client.clientId}`">
                <mat-icon>visibility</mat-icon>
                {{`${client.firstName} ${client.lastName}`}}
              </a>
              }
              @if(viewedClients.length === 0){
              <div class="no-data-found">-- {{'caseload.tabs.caseload.panel-viewed-clients.no-data' | translate}} --</div>
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <app-paged-datatable-component [columns]="clientsColumns" (pagedDatatablePageChange)="loadClientsData($event)" (pagedDatatableSortChange)="sortClientsData($event)" #clients></app-paged-datatable-component>

      </mat-tab>
    </mat-tab-group>

  </mat-card-content>
</mat-card>
